import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "../../client/components/ui/dialog";
import { Button } from "../../client/components/ui/button";
import { Input } from "../../client/components/ui/input";
import { Label } from "../../client/components/ui/label";
import useTranslation from "../../client/hooks/useTranslation";

export interface RenameLayoutDialogProps {
  open: boolean;
  onOpenChange: (b: boolean) => void;
  currentName: string;
  onConfirm: (newName: string) => void;
}

export default function RenameLayoutDialog({ open, onOpenChange, currentName, onConfirm }: RenameLayoutDialogProps) {
  const t = useTranslation();
  const [value, setValue] = useState(currentName);

  useEffect(() => {
    if (open) setValue(currentName);
  }, [open, currentName]);

  const trimmed = value.trim();
  const isValid = trimmed.length >= 1 && trimmed.length <= 50;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t.dashboard.layouts.renameDialogTitle}</DialogTitle>
        </DialogHeader>
        <div className="space-y-2">
          <Label className="text-sm">{t.dashboard.layouts.renameInputLabel}</Label>
          <Input
            value={value}
            onChange={(e) => setValue(e.target.value)}
            maxLength={50}
            autoFocus
          />
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>{t.common.cancel}</Button>
          <Button disabled={!isValid} onClick={() => { onConfirm(trimmed); onOpenChange(false); }}>
            {t.dashboard.layouts.rename}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
